import { render, staticRenderFns } from "./HeroContainer.vue?vue&type=template&id=5a1152d8&scoped=true&"
var script = {}
import style0 from "./HeroContainer.vue?vue&type=style&index=0&id=5a1152d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1152d8",
  null
  
)

export default component.exports